import { render, staticRenderFns } from "./index.vue?vue&type=template&id=787a82f6&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=787a82f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787a82f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('787a82f6')) {
      api.createRecord('787a82f6', component.options)
    } else {
      api.reload('787a82f6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=787a82f6&scoped=true&", function () {
      api.rerender('787a82f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BackToTop/index.vue"
export default component.exports